"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreHeadline = exports.HeadlineStateless = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_vis_commons_1 = require("@gooddata/sdk-ui-vis-commons");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var HeadlineTransformation_1 = tslib_1.__importDefault(require("./internal/HeadlineTransformation"));
var defaultProps_1 = require("../_commons/defaultProps");
var HeadlineStateless = /** @class */ (function (_super) {
    tslib_1.__extends(HeadlineStateless, _super);
    function HeadlineStateless(props) {
        var _this = _super.call(this, props) || this;
        _this.errorMap = sdk_ui_1.newErrorMapping(props.intl);
        return _this;
    }
    HeadlineStateless.prototype.render = function () {
        var _a = this.props, dataView = _a.dataView, error = _a.error, isLoading = _a.isLoading;
        var ErrorComponent = this.props.ErrorComponent;
        var LoadingComponent = this.props.LoadingComponent;
        if (error) {
            var errorProps = this.errorMap[Object.prototype.hasOwnProperty.call(this.errorMap, error)
                ? error
                : sdk_ui_1.ErrorCodes.UNKNOWN_ERROR];
            return ErrorComponent ? react_1.default.createElement(ErrorComponent, tslib_1.__assign({ code: error }, errorProps)) : null;
        }
        // when in pageble mode (getPage present) never show loading (its handled by the component)
        if (isLoading || !dataView) {
            return LoadingComponent ? react_1.default.createElement(LoadingComponent, null) : null;
        }
        return this.renderVisualization();
    };
    HeadlineStateless.prototype.renderVisualization = function () {
        var _a = this.props, afterRender = _a.afterRender, drillableItems = _a.drillableItems, locale = _a.locale, dataView = _a.dataView, onDrill = _a.onDrill, config = _a.config;
        return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: locale },
            react_1.default.createElement(sdk_ui_1.IntlTranslationsProvider, null, function (props) {
                // TODO: evil; fix this conceptually
                sdk_ui_vis_commons_1.fixEmptyHeaderItems(dataView, "(" + props.emptyHeaderString + ")");
                return (react_1.default.createElement(HeadlineTransformation_1.default, { dataView: dataView, onAfterRender: afterRender, onDrill: onDrill, drillableItems: drillableItems, config: config }));
            })));
    };
    HeadlineStateless.defaultProps = defaultProps_1.defaultCoreChartProps;
    return HeadlineStateless;
}(react_1.default.Component));
exports.HeadlineStateless = HeadlineStateless;
/**
 * NOTE: exported to satisfy sdk-ui-ext; is internal, must not be used outside of SDK; will disapppear.
 *
 * @internal
 */
exports.CoreHeadline = sdk_ui_1.withEntireDataView(HeadlineStateless);
//# sourceMappingURL=CoreHeadline.js.map